import { gql, TypedDocumentNode } from "@apollo/client";

import { LogsDownloadUrl, Run, Stack } from "types/generated";

type GetStackRunTraceDownloadUrlData = {
  stack:
    | (Pick<Stack, "id"> & {
        run:
          | (Pick<Run, "id"> & {
              otelTraceForJaegerDownloadURL: Pick<LogsDownloadUrl, "url"> | null;
            })
          | null;
      })
    | null;
};

type GetStackRunTraceDownloadUrlVariables = {
  stackId: string;
  runId: string;
};

export const GET_STACK_RUN_TRACE_DOWNLOAD_URL: TypedDocumentNode<
  GetStackRunTraceDownloadUrlData,
  GetStackRunTraceDownloadUrlVariables
> = gql`
  query GetStackRunTraceDownloadURL($stackId: ID!, $runId: ID!) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        otelTraceForJaegerDownloadURL {
          url
        }
      }
    }
  }
`;
